import space from '@styled-system/space'
import { em } from 'polished'
import styled from 'styled-components'

import ButtonRoundedSt from 'components/ButtonRoundedSt'
import { BoxBase, Col, Row } from 'styles/components/layout'
import { TextLH } from 'styles/components/typography'

export const BoxBaseStyled = styled(BoxBase)``

export const RowStyled = styled(Row)`
  margin-top: ${em(25)};

  ${p => p.theme.mq.upMd} {
    margin-top: ${em(40)};
  }

  ${p => p.theme.mq.upLg} {
    margin-top: ${em(60)};
  }
`

export const ColStyled = styled(Col)`
  ${space};
`

export const Divider = styled.div`
  border-top: 1px solid ${p => p.theme.colors.blackOp07};
`

export const ButtonContent = styled.div`
  width: ${em(280)};
  text-align: center;
  margin: 0 auto;

  ${p => p.theme.mq.upMd} {
    width: auto;
    padding: 0 ${em(46)};
  }
`

export const AddProductTitle = styled.h3`
  font-family: ${p => p.theme.typography.mediumFont};
  font-size: ${p => p.theme.typography.cartItemFontSize};
  line-height: ${p => p.theme.typography.cartItemFontLh};
  font-weight: 400;
  margin-bottom: ${p => em(14, p.theme.typography.cartItemFontSizePx)};
  margin-top: ${p => em(44, p.theme.typography.cartItemFontSizePx)};

  ${p => p.theme.mq.upMd} {
    font-size: ${p => p.theme.typography.h3};
    line-height: ${p => p.theme.typography.h3Lh};
    margin-bottom: ${p => em(34, p.theme.typography.h3px)};
    margin-top: ${p => em(110, p.theme.typography.h3px)};
  }

  ${p => p.theme.mq.upLg} {
    font-family: ${p => p.theme.typography.baseFont};
  }
`

export const TextLHStyled = styled(TextLH)`
  font-size: ${p => p.theme.typography.cartItemFontSize};
`

export const ButtonRoundedStStyled = styled(ButtonRoundedSt)`
  display: block;
  width: 100%;
`
